const e={truncate:{type:"boolean",className:"rt-truncate"}};export{e as truncatePropDef};
//# sourceMappingURL=truncate.prop.js.map
